define(['angular', '../module', './commentsModal.controller'], function(angular, MODULE_NAME, CommentsModalController) {
    'use strict';

   var SERVICE_NAME = 'ilmnUiCommentsModalService';
   var templateUrl = require('../views/commentsDialog.template.html');
   var styles = require('./commentsModal.styles.less');

    angular.module(MODULE_NAME)
        .service(SERVICE_NAME, CommentsModalService);

    CommentsModalService.$inject = ['$uibModal'];
    function CommentsModalService($uibModal) {
        return {
            open: function (options) {
                return $uibModal.open({
                    templateUrl: templateUrl,
                    controller: CommentsModalController,
                    controllerAs: 'vm',
                    bindToController: true,
                    backdrop: true,
                    keyboard: false,
                    modalFade: true,
                    size: 'xl',
                    windowClass: 'ilmn-modal-double-panel',
                    resolve: {
                        options: function() {
                            return options;
                        }
                    }
                });
            }
        }
    }

    return SERVICE_NAME;
});



//////////////////
// WEBPACK FOOTER
// ./ilmn-ui-comments/scripts/commentsModal.service.js
// module id = 23
// module chunks = 0